import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IAttachmentModel } from '../../../../models/attachment/attachment.model';
import { INodeInstanceViewModel } from '../../../../models/node/node-instance.view.model';
import { IProjectModel } from '../../../../models/project/project.model';
import { IWorkspaceInstanceModel } from '../../../../models/workspace/workspace-instance.model';

@Component({
  selector: 'app-edit-panel-steps-pane',
  templateUrl: './edit-panel-steps-pane.component.html',
  styleUrls: ['./edit-panel-steps-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EditPanelStepsPaneComponent {
  @Input() numberOfTestSteps = 0;
  @Input() expanded = false;
  @Input() tableName: string | null = null;
  @Input() tableData: any[] | null = null;
  @Input() tableConfig: any;
  @Input() tableIndex: number | null = null;
  @Input() selectedNode: INodeInstanceViewModel | null = null;
  @Input() selectedProject: IProjectModel | null = null;
  @Input() selectedWorkspace: IWorkspaceInstanceModel | null = null;
  @Input() attachmentsOrg: IAttachmentModel[] = [];
  @Input() isAutoNumberColumn = false;
  /** Backlog roll-up: the steps shown belong to another label, so they cannot be changed here. */
  @Input() readOnly = false;

  @Output() expandedChange = new EventEmitter<boolean>();
  @Output() tableDataOutput = new EventEmitter<any>();
  @Output() tableEdit = new EventEmitter<void>();

  public openTableDetails(): void {
    if (!this.expanded) {
      this.expandedChange.emit(true);
    }
  }

  public onTableDataOutput(event: any): void {
    this.tableDataOutput.emit(event);
  }

  public onTableEdit(): void {
    this.tableEdit.emit();
  }
}
